import { FC } from 'react';
import { Card, withStyles } from 'vopay';
import styles from './DialogLink.module.scss';
import { CopyButton } from '@/components/UI';
import LinkButton from '../LinkButton';

const cn = withStyles(styles);

type DialogLinkProps = { label: string; link: string };

const DialogLink: FC<DialogLinkProps> = ({ label, link }) => {
  return (
    <div className={cn('dialogLinkContainer')}>
      <div className={cn('label')}>{label}</div>

      <Card
        style={{
          backgroundColor: 'hsl(0, 0%, 95%)',
          borderRadius: 14,
          padding: '24px',
          borderColor: 'hsl(0deg 0% 88%)',
          borderWidth: 1,
        }}
        hoverEffect={false}
        className={cn('card')}
      >
        <div className={cn('href')}>{link}</div>

        <div className={cn('icons')}>
          <CopyButton content={link} />
          <LinkButton link={link} />
        </div>
      </Card>
    </div>
  );
};

export default DialogLink;
